import React from 'react';
import { Switch } from 'react-router-dom';
import { connect } from 'react-redux';
import './app.css';
import {
  logout,
  validateUserSession,
} from '../../redux/services/login-service/loginService';
import { bindActionCreators } from 'redux';
import LoginContainer from '../../containers/login-container/login-container';
import RegisterContainer from '../../containers/register-container/register-container';
import ResetPasswordContainer from '../../containers/reset-password-container/reset-password-container';
import HomeContainer from '../../containers/home-container/home-container';
import CustomerInfoContainer from '../../containers/customer-info-container/customer-info-container';
import LogoutContainer from '../../containers/logout-container/logout-container';
import Header from '../common/Header/Header';
import PropTypes from 'prop-types';
import Banner from '../common/banner/banner';
import AgentDisabledForm from '../../components/agent-disabled/agent-disabled';
import AgentAccountDisableForm from '../../components/account-disable/account-disable';
import AgentProfileContainer from '../../containers/agent-profile-container/agent-profile-container';
import ConfirmationPage from '../summary-page/summary-page';
import SuccessInfoForm from '../confirmation-page/confirmation-page';
import ErrorForm from '../error-page/error-page';
import Footer from '../common/Footer/Footer';
import IdleTimer from 'react-idle-timer';
import { IdleTimeOutModal } from '../common/idle-timer-modal/idle-timer-modal';
import PrivateRoute from '../routes/PrivateRoute';
import PublicRoute from '../routes/PublicRoute';
import DefaultRoute from '../routes/DefaultRoute';

export class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      timeout: 900000,
      showModal: false,
      isTimedOut: false,
    };
    this.idleTimer = null;
    this.onAction = this._onAction.bind(this);
    this.onActive = this._onActive.bind(this);
    this.onIdle = this._onIdle.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleWindowClose = this.handleWindowClose.bind(this);
  }

  UNSAFE_componentWillMount = () => {
    // console.log('App.componentWillMount() props: ', this.props);
    // if session contains valid
    if (localStorage.getItem('access_token') !== null) {
      this.validateUser();
    }

    window.addEventListener('beforeunload', this.handleWindowClose);
  };

  UNSAFE_componentWillUnMount = () => {
    window.removeEventListener('beforeunload', this.handleWindowClose);
  };

  handleWindowClose = async e => {
    e.preventDefault();
    // dispatch a UNAUTH_USER action to invoke Cognito
  };

  validateUser = () => {
    // get current authenticated user
    this.props.validateUserSession();
  };

  handleClose = () => {
    this.setState({ showModal: false });
  };

  signOut = () => {
    this.setState({ showModal: false });
    this.props.history.push('/');
    this.props.logOut();
  };

  _onAction = e => {
    console.log(e);
    this.setState({ isTimedOut: false });
  };

  _onActive = e => {
    console.log(e);
    this.setState({ isTimedOut: false });
  };

  _onIdle = e => {
    console.log(e);
    const isTimedOut = this.state.isTimedOut;
    if (isTimedOut) {
      this.signOut();
    } else {
      this.setState({ showModal: true });
      this.idleTimer.reset();
      this.setState({ isTimedOut: true });
    }
  };

  render() {
    // console.log('store-this.props', this.props);
    return (
      <React.Fragment>
        <div>
          <IdleTimer
            ref={ref => {
              this.idleTimer = ref;
            }}
            element={document}
            onActive={this.onActive}
            onIdle={this.onIdle}
            onAction={this.onAction}
            debounce={250}
            timeout={this.state.timeout}
          />
          {/* your app here */}
        </div>
        <div className="container page">
          <Header
            appName={this.props.appName}
            currentUser={this.props.currentUser}
            logout={this.signOut}
            isAuthenticated={this.props.isAuthenticated}
            appLoaded={true}
          />
          <Banner appLoaded={true} />

          <Switch>
            <DefaultRoute
              exact
              path="/"
              component={LoginContainer}
              authStatus={this.props.isAuthenticated}
            />
            <PublicRoute
              exact
              path="/noncashdep/"
              component={LoginContainer}
              authStatus={this.props.isAuthenticated}
            />
            <DefaultRoute
              path="/noncashdep/*"
              component={LoginContainer}
              authStatus={this.props.isAuthenticated}
            />
            <PublicRoute
              exact
              path="/login"
              component={LoginContainer}
              authStatus={this.props.isAuthenticated}
            />
            <PublicRoute
              exact
              path="/reset"
              component={ResetPasswordContainer}
              authStatus={this.props.isAuthenticated}
            />
            <PublicRoute
              exact
              path="/register"
              component={RegisterContainer}
              authStatus={this.props.isAuthenticated}
            />
            <PrivateRoute
              exact
              path="/logout"
              component={LogoutContainer}
              authStatus={this.props.isAuthenticated}
            />
            <PrivateRoute
              exact
              path="/disable"
              component={AgentDisabledForm}
              authStatus={this.props.isAuthenticated}
            />
            <PrivateRoute
              exact
              path="/error"
              component={ErrorForm}
              authStatus={this.props.isAuthenticated}
            />
            <PrivateRoute
              exact
              path="/home"
              component={HomeContainer}
              authStatus={this.props.isAuthenticated}
            />
            <PrivateRoute
              exact
              path="/info"
              component={CustomerInfoContainer}
              authStatus={this.props.isAuthenticated}
            />
            <PrivateRoute
              exact
              path="/confirm"
              component={ConfirmationPage}
              authStatus={this.props.isAuthenticated}
            />
            <PrivateRoute
              exact
              path="/submitSuccess"
              component={SuccessInfoForm}
              authStatus={this.props.isAuthenticated}
            />

            <PrivateRoute
              exact
              path="/accountDisable"
              component={AgentAccountDisableForm}
              authStatus={this.props.isAuthenticated}
            />
            <PrivateRoute
              exact
              path="/profile"
              component={AgentProfileContainer}
              authStatus={this.props.isAuthenticated}
            />
          </Switch>

          {this.props.isAuthenticated && (
            <IdleTimeOutModal
              showModal={this.state.showModal}
              handleClose={this.handleClose}
              handleLogout={this.signOut.bind(this)}
            />
          )}
          <Footer isAuthenticated={this.props.isAuthenticated} />
        </div>
      </React.Fragment>
    );
  }
}

App.contextTypes = {
  router: PropTypes.object.isRequired,
};

const mapStateToProps = state => {
  return {
    appLoaded: state.appReducer.appLoaded,
    isAuthenticated: state.appReducer.isAuthenticated,
    appName: state.appReducer.appName,
    currentUser: state.appReducer.currentUser,
  };
};

const mapDispatchToProps = dispatch => ({
  logOut: bindActionCreators(logout, dispatch),
  validateUserSession: bindActionCreators(validateUserSession, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(App);

App.propTypes = {
  appName: PropTypes.string.isRequired,
  appLoaded: PropTypes.bool.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  currentUser: PropTypes.object,
  router: PropTypes.object,
  logOut: PropTypes.func.isRequired,
  validateUserSession: PropTypes.func.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func,
  }),
};
